import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "lodash";

@Pipe({
  name: 'storeFilter'
})
export class StoreFilterPipe implements PipeTransform {

  transform(items: any, po: any[]): any {

    let eCompany = _.get(po, ['EnterpriseCompany','@odata.id'])

    let retVal = items.filter( i => {
      let eCompanyInStore = _.get(i, ['EnterpriseCompany','@odata.id']);

      return _.isNull(i.EnterpriseCompany) || eCompany == eCompanyInStore;
    });

    return retVal;
  }

}
